const features = [
  {
    icon: 'ri-shield-check-line',
    title: '安全稳定',
    desc: '多重安全防护，纯净无广告弹窗，为您的观影体验保驾护航。所有片源经过严格筛选，确保内容安全可靠。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速播放',
    desc: '智能CDN多节点加速，自适应带宽优化，无论标清还是1080P高清，都能做到秒开不缓冲，观影零等待。',
  },
  {
    icon: 'ri-stack-line',
    title: '海量片库',
    desc: '汇聚西瓜视频免费、菠萝视频、青青草视频等主流平台资源，超过两万部影视内容持续更新，总有您想看的。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            特色优势
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            为什么数百万人选择神马视频
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 max-w-4xl mx-auto">
          {features.map((feat, i) => (
            <div key={i} className="text-center group">
              <div className="w-16 h-16 mx-auto mb-4 rounded-2xl bg-primary-50 flex items-center justify-center group-hover:bg-primary-100 transition-colors">
                <i className={`${feat.icon} text-2xl text-primary-500`}></i>
              </div>
              <h3 className="text-lg font-heading font-bold text-foreground-900 mb-2">
                {feat.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}